import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PrismicLink } from '@prismicio/react'

const CardDeck = ({ slice }) => {
  return (
    <section className='component-featured_cards mx-auto max-w-screen-xl p-6'>
      <ul className={`grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-10`}>
        {slice.items.map((card, index) => {
          return (
            <li
              className='group relative grid max-h-64 grid-cols-1 grid-rows-1 overflow-hidden rounded-lg border border-secondary shadow-md transition duration-200 ease-in hover:scale-105 hover:shadow-lg'
              key={`featcard-${index}`}>
              {card.image.gatsbyImageData && (
                <div className='col-span-full row-span-full h-full'>
                  <GatsbyImage className='h-full object-cover opacity-25' image={card.image.gatsbyImageData} alt={card.image.alt || ''} />
                </div>
              )}
              <div className='col-span-full row-span-full flex w-full flex-col items-start p-6 lg:p-10'>
                <div className='space-y-2'>
                  <div className='text-3xl text-primary lg:text-4xl'>{card.card_title}</div>
                  {card.card_text && <div className='text-base md:text-lg'>{card.card_text}</div>}
                </div>
                {card.link?.url && (
                  <PrismicLink className='link absolute inset-0' href={card.link.url}>
                    <span className='sr-only'>{card.button_text}</span>
                  </PrismicLink>
                )}
                <div className='button button-primary mt-auto inline-flex w-auto group-hover:opacity-80'>{card.button_text || 'find out more'}</div>
              </div>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
export default CardDeck
